export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
// 'https://forkify-api.herokuapp.com/api/v2/recipes/5ed6604591c37cdc054bc886'

export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'e984af93-8afe-45ba-a9df-8aaae5db5a7a';
export const MODAL_CLOSE_SEC = 2.5;
// https://forkify-api.herokuapp.com/v2

//"@babel/plugin-proposal-private-methods": "^7.16.11",
// "@babel/plugin-proposal-private-property-in-object": "^7.16.7",
/*
"babel": {
    "plugins": [
      "@babel/plugin-proposal-class-properties",
      "@babel/plugin-proposal-private-methods"
    ]
  }
*/
